/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for highLevelDataType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="highLevelDataType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="boolean"/&gt; &lt;enumeration value="string"/&gt; &lt;enumeration value="integer"/&gt; &lt;enumeration value="decimal"/&gt; &lt;enumeration value="datetime"/&gt; &lt;enumeration value="time"/&gt; &lt;enumeration value="date"/&gt; &lt;enumeration value="interval"/&gt; &lt;enumeration value="array"/&gt; &lt;enumeration value="object"/&gt; &lt;enumeration value="period"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class HighLevelDataType extends Enum{

	enumValue = null;

	static  BOOLEAN = HighLevelDataType.newLiteral("boolean");

	static  STRING = HighLevelDataType.newLiteral("string");

	static  INTEGER = HighLevelDataType.newLiteral("integer");

	static  DECIMAL = HighLevelDataType.newLiteral("decimal");

	static  DATETIME = HighLevelDataType.newLiteral("datetime");

	static  TIME = HighLevelDataType.newLiteral("time");

	static  DATE = HighLevelDataType.newLiteral("date");

	static  INTERVAL = HighLevelDataType.newLiteral("interval");

	static  ARRAY = HighLevelDataType.newLiteral("array");

	static  OBJECT = HighLevelDataType.newLiteral("object");

	static  PERIOD = HighLevelDataType.newLiteral("period");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	static fromValue(v) {
		for (var i = 0; (i < HighLevelDataType.values().length); ++i) {
			if (HighLevelDataType.values()[i].enumValue == v) {
				return HighLevelDataType.values()[i];
			}
		}
		throw new Error(v);
	}

	value() {
		return this.enumValue;
	}

	getResourceId() {
		return (("HighLevelDataType" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/HighLevelDataType.js